<template>
  <o-section
    :level="level + 1"
    :title="label || schema.verbose_name"
    body-classes="p-0"
    not-closable
  >
    <o-item-editable-table
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      @change="changed"
      v-model="items"
    >
      <template slot="o-headers">
        <th v-if="canSee(schema, 'description')">
          {{ schema.fields.description.label }}
        </th>
        <th v-if="canSee(schema, 'best_case')">
          {{ schema.fields.best_case.label }}
        </th>
        <th v-if="canSee(schema, 'most_likely_case')">
          {{ schema.fields.most_likely_case.label }}
        </th>
        <th v-if="canSee(schema, 'worst_case')">
          {{ schema.fields.worst_case.label }}
        </th>
        <th v-if="canSee(schema, 'expected_case')">
          {{ schema.fields.expected_case.label }}
        </th>
      </template>
      <template slot="o-body" slot-scope="{ item, index }">
        <td v-if="canSee(schema, 'description')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="description"
          >
            <o-text-field
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="description"
              nolabel
              v-bind="schema.fields.description"
              v-model="items[index].description"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'best_case')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="best_case"
          >
            <o-text-field
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="best_case"
              nolabel
              v-bind="schema.fields.best_case"
              v-model="items[index].best_case"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'most_likely_case')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="most_likely_case"
          >
            <o-text-field
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="most_likely_case"
              nolabel
              v-bind="schema.fields.most_likely_case"
              v-model="items[index].most_likely_case"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'worst_case')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="worst_case"
          >
            <o-text-field
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="worst_case"
              nolabel
              v-bind="schema.fields.worst_case"
              v-model="items[index].worst_case"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'expected_case')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="expected_case"
          >
            <o-text-field
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="expected_case"
              nolabel
              v-bind="schema.fields.expected_case"
              v-model="items[index].expected_case"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../vue-ocom/mixins";
import OItemEditableTable from "../../../vue-ocom/components/table/OItemEditableTable";
import OSection from "../../../vue-ocom/components/layout/OSection";

export default {
  name: "QuoteLineFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("QuoteLine"),
    CreateCodeTableFetchMixin([]),
  ],
  components: { OItemEditableTable, OSection },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.QuoteLine,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.QuoteLine),
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {},
  created() {
    // this.loadCodeTables()
  },
};
</script>
